module.exports = __webpack_public_path__ + "static/media/power-meter-image.d49cb100.png";